import React, { useEffect, useState } from "react";
import { Textfield } from "../../../../components/core";
import { NumberFormatBase } from "react-number-format";

export default function LockerTimeLimitTable({
	className,
	data = {},
	handleChange,
	disabled = false,
	editingDone,
	valueChanged,
	refetch,
	isSuccess,
	setIsSuccess,
}) {
	const companyName = localStorage.getItem("user")
		? JSON.parse(localStorage.getItem("user")).company
		: "";
	const [fieldEdited, setFieldEdited] = useState({
		pickupTakebackLimit: false,
		pickupPulloutLimit: false,
		shipoutBookingExpiry: false,
		shipoutTakebackLimit: false,
		shipoutPulloutLimit: false,
	});
	console.log({ isSuccess, fieldEdited });

	useEffect(() => {
		if (isSuccess) {
			setFieldEdited({
				pickupTakebackLimit: false,
				pickupPulloutLimit: false,
				shipoutBookingExpiry: false,
				shipoutTakebackLimit: false,
				shipoutPulloutLimit: false,
			});
		}
	}, [isSuccess]);

	const handleFieldChange = (e) => {
		const { name, value } = e.target;
		// Validate numeric input
		if (/^(\d+)?$/.test(value)) {
			handleChange(e); // Call the parent change handler
			setIsSuccess(false);
			setFieldEdited((prev) => ({ ...prev, [name]: true })); // Mark the field as edited
		}
	};

	const renderIcon = (fieldName, value, maxLimit = 720) => {
		if (!fieldEdited[fieldName]) {
			return <div className="h-6"></div>;
		}

		if (value === "" || value == null || isNaN(Number(value))) {
			return (
				<i
					className="pi pi-exclamation-triangle text-orange-400"
					style={{ fontSize: "1.5rem" }}
					// title="Value is missing or invalid"
				></i>
			);
		}

		return value > maxLimit ? (
			<i
				className="pi pi-exclamation-circle text-red-400"
				style={{ fontSize: "1.5rem" }}
				// title="Value exceeds the maximum limit"
			></i>
		) : (
			<i
				className="pi pi-check-circle text-green-400"
				style={{ fontSize: "1.5rem" }}
				// title="Value is within the maximum limit"
			></i>
		);
	};

	return (
		<div>
			<div className="mb-2">
				<div className="bg-primary-primaryYellow text-center p-2 font-bold">
					Pickup Time Limits
				</div>

				<div className="flex flex-col border-secondary-buttonHeaderGray border-x-2 border-b-2 p-2">
					<div className="flex h-auto gap-3 justify-center items-center">
						<div className="w-2/3">
							<p className="text-lg font-semibold">Takeback Alert Limit:</p>
							<p className="text-sm">
								Maximum time allowed for a recipient to collect a package before
								a take-back request is sent to the courier.
							</p>
						</div>

						<div className="grid grid-cols-9 w-1/3 items-center">
							<div className="col-span-1 flex justify-start items-center">
								<div className="col-span-1 flex justify-start items-center">
									{renderIcon("pickupTakebackLimit", data.pickupTakebackLimit)}
								</div>
							</div>

							<Textfield
								disabled={disabled}
								classNameParent={"col-span-7"}
								placeholder={"XXX"}
								className={`${
									fieldEdited.pickupTakebackLimit &&
									data.pickupTakebackLimit > 720
										? "border border-red-400 w-full my-auto"
										: ""
								}`}
								min={1}
								maxLength={3}
								value={data.pickupTakebackLimit}
								name="pickupTakebackLimit"
								onChange={(e) => {
									var numberPattern = /^(\d+)?$/;
									if (numberPattern.test(e.target.value)) {
										handleChange(e);
									}
									handleFieldChange(e);
								}}
							/>

							<p className="col-span-1 grid items-center justify-center">hrs</p>
						</div>
					</div>

					<div className="grid grid-cols-12 w-full">
						<div className="col-span-8"></div>

						<div className="col-span-4">
							<div className="justify-center grid w-full items-center">
								{fieldEdited.pickupTakebackLimit &&
									(!data.pickupTakebackLimit ||
									data.pickupTakebackLimit === "" ? (
										<span className="col-span-7 text-orange-400">
											The field is required.
										</span>
									) : (
										data.pickupTakebackLimit > 720 && (
											<span className="col-span-7 text-red-400">
												Invalid value! Maximum hour is 720.
											</span>
										)
									))}
							</div>
						</div>
					</div>
				</div>

				<div className="flex flex-col border-secondary-buttonHeaderGray border-x-2 border-b-2 p-2">
					<div className="flex h-auto gap-3 justify-center items-center">
						<div className="w-2/3">
							<p className="text-lg font-semibold">Pullout Alert Limit:</p>
							<p className="text-sm">
								Maximum time allowed for a courier to respond to a take-back
								package alert before a pullout alert is sent.
							</p>
						</div>

						<div className="grid grid-cols-9 w-1/3 items-center">
							<div className="col-span-1 flex justify-start items-center">
								<div className="col-span-1 flex justify-start items-center">
									{renderIcon("pickupPulloutLimit", data.pickupPulloutLimit)}
								</div>
							</div>

							<Textfield
								disabled={disabled}
								classNameParent={"col-span-7"}
								placeholder={"XXX"}
								value={data.pickupPulloutLimit}
								min={1}
								maxLength={3}
								className={`${
									fieldEdited.pickupPulloutLimit &&
									data.pickupPulloutLimit > 720
										? "border border-red-400 w-full my-auto"
										: ""
								}`}
								name="pickupPulloutLimit"
								onChange={(e) => {
									var numberPattern = /^(\d+)?$/;
									if (numberPattern.test(e.target.value)) {
										handleChange(e);
									}
									handleFieldChange(e);
								}}
							/>
							<p className="col-span-1 grid items-center justify-center">hrs</p>
						</div>
					</div>

					<div className="grid grid-cols-12 w-full">
						<div className="col-span-8"></div>

						<div className="col-span-4">
							<div className="justify-center grid w-full items-center">
								{fieldEdited.pickupPulloutLimit &&
									(!data.pickupPulloutLimit ||
									data.pickupPulloutLimit === "" ? (
										<span className="col-span-7 text-orange-400">
											The field is required.
										</span>
									) : (
										data.pickupPulloutLimit > 720 && (
											<span className="col-span-7 text-red-400">
												Invalid value! Maximum hour is 720.
											</span>
										)
									))}
							</div>
						</div>
					</div>
				</div>
			</div>

			{companyName === "MBOX" && (
				<div>
					<div className="bg-primary-primaryYellow text-center p-2 font-bold">
						Shipout Time Limits
					</div>

					<div className="flex flex-col border-secondary-buttonHeaderGray border-x-2 border-b-2 p-2">
						<div className="flex h-auto gap-3 justify-center items-center">
							<div className="w-2/3">
								<p className="text-lg font-semibold"> Booking Expiry:</p>
								<p className="text-sm">
									Maximum time sender has to put the item inside the locker
									before booking expires.
								</p>
							</div>

							<div className="grid grid-cols-9 w-1/3 items-center">
								<div className="col-span-1 flex justify-start items-center">
									{/* {editingDone ? ( */}
									<div className="col-span-1 flex justify-start items-center">
										{renderIcon(
											"shipoutBookingExpiry",
											data.shipoutBookingExpiry
										)}
									</div>
								</div>

								<Textfield
									disabled={disabled}
									classNameParent={"col-span-7"}
									placeholder={"XXX"}
									value={data.shipoutBookingExpiry}
									name="shipoutBookingExpiry"
									className={`${
										fieldEdited.shipoutBookingExpiry &&
										data.shipoutBookingExpiry > 720
											? "border border-red-400 w-full my-auto"
											: ""
									}`}
									min={1}
									maxLength={3}
									onChange={(e) => {
										var numberPattern = /^(\d+)?$/;
										if (numberPattern.test(e.target.value)) {
											handleChange(e);
										}
										handleFieldChange(e);
									}}
								/>
								<p className="col-span-1 grid items-center justify-center">
									hrs
								</p>
							</div>
						</div>

						<div className="grid grid-cols-12 w-full">
							<div className="col-span-8"></div>

							<div className="col-span-4">
								<div className="justify-center grid w-full items-center">
									{fieldEdited.shipoutBookingExpiry &&
										(!data.shipoutBookingExpiry ||
										data.shipoutBookingExpiry === "" ? (
											<span className="col-span-7 text-orange-400">
												The field is required.
											</span>
										) : (
											data.shipoutBookingExpiry > 720 && (
												<span className="col-span-7 text-red-400">
													Invalid value! Maximum hour is 720.
												</span>
											)
										))}
								</div>
							</div>
						</div>
					</div>

					<div className="flex flex-col border-secondary-buttonHeaderGray border-x-2 border-b-2 p-2">
						<div className="flex h-auto gap-3 justify-center items-center">
							<div className="w-2/3">
								<p className="text-lg font-semibold">
									{" "}
									Shipout Takeback Alert Limit:
								</p>
								<p className="text-sm">
									Maximum time a courier has to collect an item for shipout.
									Beyond this, sender will be sent a failed shipout alert and
									asked to retrieve back package.
								</p>
							</div>

							<div className="grid grid-cols-9 w-1/3 items-center">
								<div className="col-span-1 flex justify-start items-center">
									<div className="col-span-1 flex justify-start items-center">
										{renderIcon(
											"shipoutTakebackLimit",
											data.shipoutTakebackLimit
										)}
									</div>
								</div>

								<Textfield
									disabled={disabled}
									classNameParent={"col-span-7"}
									placeholder={"XXX"}
									value={data.shipoutTakebackLimit}
									className={`${
										fieldEdited.shipoutTakebackLimit &&
										data.shipoutTakebackLimit > 720
											? "border border-red-400 w-full my-auto"
											: ""
									}`}
									name="shipoutTakebackLimit"
									min={1}
									maxLength={3}
									onChange={(e) => {
										var numberPattern = /^(\d+)?$/;
										if (numberPattern.test(e.target.value)) {
											handleChange(e);
										}
										handleFieldChange(e);
									}}
								/>
								<p className="col-span-1 grid items-center justify-center">
									hrs
								</p>
							</div>
						</div>

						<div className="grid grid-cols-12 w-full">
							<div className="col-span-8"></div>

							<div className="col-span-4">
								<div className="justify-center grid w-full items-center">
									{fieldEdited.shipoutTakebackLimit &&
										(!data.shipoutTakebackLimit ||
										data.shipoutTakebackLimit === "" ? (
											<span className="col-span-7 text-orange-400">
												The field is required.
											</span>
										) : (
											data.shipoutTakebackLimit > 720 && (
												<span className="col-span-7 text-red-400">
													Invalid value! Maximum hour is 720.
												</span>
											)
										))}
								</div>
							</div>
						</div>
					</div>

					<div className="flex flex-col border-secondary-buttonHeaderGray border-x-2 border-b-2 p-2">
						<div className="flex h-auto gap-3 justify-center items-center">
							<div className="w-2/3">
								<p className="text-lg font-semibold">Pullout Alert Limit:</p>
								<p className="text-sm">
									Maximum time a sender has to act on a take back package alert
									before a pullout Alert is sent.
								</p>
							</div>

							<div className="grid grid-cols-9 w-1/3 items-center">
								<div className="col-span-1 flex justify-start items-center">
									<div className="col-span-1 flex justify-start items-center">
										{renderIcon(
											"shipoutPulloutLimit",
											data.shipoutPulloutLimit
										)}
									</div>
								</div>

								<Textfield
									disabled={disabled}
									classNameParent={"col-span-7"}
									placeholder={"XXX"}
									value={data.shipoutPulloutLimit}
									name="shipoutPulloutLimit"
									min={1}
									maxLength={3}
									className={`${
										fieldEdited.shipoutPulloutLimit &&
										data.shipoutPulloutLimit > 720
											? "border border-red-400 w-full my-auto"
											: ""
									}`}
									onChange={(e) => {
										var numberPattern = /^(\d+)?$/;
										if (numberPattern.test(e.target.value)) {
											handleChange(e);
										}
										handleFieldChange(e);
									}}
								/>
								<p className="col-span-1 grid items-center justify-center">
									hrs
								</p>
							</div>
						</div>
						<div className="grid grid-cols-12 w-full">
							<div className="col-span-8"></div>

							<div className="col-span-4">
								<div className="justify-center grid w-full items-center">
									{fieldEdited.shipoutPulloutLimit &&
										(!data.shipoutPulloutLimit ||
										data.shipoutPulloutLimit === "" ? (
											<span className="col-span-7 text-orange-400">
												The field is required.
											</span>
										) : (
											data.shipoutPulloutLimit > 720 && (
												<span className="col-span-7 text-red-400">
													Invalid value! Maximum hour is 720.
												</span>
											)
										))}
								</div>
							</div>
						</div>
					</div>
				</div>
			)}
		</div>
	);
}
